export default __webpack_public_path__ + "static/media/placeholder_store03-nl-web.3b4c1bf2.png";